export default __webpack_public_path__ + "static/media/go-back-black.e518d05a.svg";